"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneNumberComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Translations = require("react-platform-components/dist/Translations");
var _materialUiPhoneNumber = _interopRequireDefault(require("material-ui-phone-number"));
var _excluded = ["field", "form"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Create phone field component from Material UI TextField
var PhoneNumberComponent = function PhoneNumberComponent(_ref) {
  var field = _ref.field,
    form = _ref.form,
    props = _objectWithoutProperties(_ref, _excluded);
  var meta = form.getFieldMeta(field.name);
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  var outlinedInputProps = ['autoComplete', 'autoFocus', 'classes', 'color', 'defaultValue', 'disabled', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'labelWidth', 'margin', 'name', 'notched', 'onChange', 'placeholder', 'readOnly', 'required', 'value', 'size', 'className', 'style', 'InputProps'];
  return /*#__PURE__*/_react.default.createElement(_materialUiPhoneNumber.default, _extends({
    id: field.name,
    "aria-describedby": field.name,
    defaultCountry: props.country || "fr",
    disableAreaCodes: true,
    variant: "outlined",
    label: props.label ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: props.label,
      defaultMessage: props.label
    }) : null
  }, field, {
    onChange: function onChange(value) {
      field.onChange({
        target: {
          name: field.name,
          type: 'text',
          value: value
        }
      });
    }
  }, _lodash.default.pick(props, outlinedInputProps), {
    error: hasError
  }, hasError ? {
    helperText: meta.error
  } : null));
};
exports.PhoneNumberComponent = PhoneNumberComponent;